module.exports = __webpack_public_path__ + "img/coloredDiamonds@2x.95f8f80.jpg";